import type { DateIso, Deal, DealLine, Phase } from '../../types/domain';

// Lien affaire ↔ phases : une phase convertie porte la ligne vendue dont elle est issue
// (ligneId) ; les phases converties avant ce lien se retrouvent par converted_phase_id.
const isFromDeal = (deal: Deal, phase: Phase): boolean =>
  (!!phase.ligneId && (deal.lignes || []).some((l) => l.id === phase.ligneId)) ||
  deal.converted_phase_id === phase.id;

/* Affaire d'origine d'une phase, ou null pour une phase hors CRM (client Interne). */
export function dealOfPhase(deals: Deal[] | null | undefined, phase: Phase): Deal | null {
  return (deals || []).find((a) => isFromDeal(a, phase)) || null;
}

/* Ligne vendue dont la phase est issue, ou null (phase interne, ou convertie avant ce lien). */
export function lineOfPhase(deals: Deal[] | null | undefined, phase: Phase): DealLine | null {
  if (!phase.ligneId) return null;
  return (dealOfPhase(deals, phase)?.lignes || []).find((l) => l.id === phase.ligneId) || null;
}

/* Phases issues d'une affaire, parmi les phases d'un client. */
export function phasesOfDeal(deal: Deal, phases: Phase[] | null | undefined): Phase[] {
  return (phases || []).filter((ph) => isFromDeal(deal, ph));
}

/* Toutes les phases sont clôturées à la date donnée (fin atteinte, comme le badge « Clôturée »). */
export function allPhasesClosed(phases: Phase[], todayIso: DateIso): boolean {
  return phases.length > 0 && phases.every((ph) => !!ph.dateFin && ph.dateFin <= todayIso);
}
